import { HubOverview } from '../../models';

export class HubOverviewLoad {
  public static readonly type = '[HubOverview] Load Overview';
  constructor(public payload: number) {}
}

export class HubOverviewUpdate {
  public static readonly type = '[HubOverview] Update Overview';
  constructor(public payload: HubOverview) {}
}

export class HubOverviewInitialState {
  public static readonly type = '[HubOverview] Set Initial State';
}
